// This file is generated by scripts/generate-app-version.js.
// Do not edit it manually.
export const APP_VERSION = "0.9.0";
export const APP_BUILD_TIME = "2026-11-01T15:07:30.763Z";

export default APP_VERSION;
